<template>
    <div class="pic-container" :class="isVertical ? 'vertical': 'horizontal'" :style="`background-image: url(${noticeData.imgUrl})`" @click.self="$parent.giveOutLink(noticeData.linkUrl)">
        <!-- <img class="g-img-full" :src="noticeData.imgUrl" :alt="noticeData.title" @click="$parent.giveOutLink(noticeData.linkUrl)"> -->
        <span class="notice-close" @click="$parent.closeWindow"></span>
    </div>
</template>
<script>
export default {
    name: 'PicComponent',
    props: {
        noticeData: {
            required: true,
            type: Object
        },
        isVertical: {
            required: true,
            type: Boolean
        }
    }
}
</script>
<style lang="less" scoped>
.pic-container {
    position: absolute;
    max-width: 500px;
    max-height: 90vh;
    transform: translate(-50%, -50%);
    overflow: auto;
    left: 50%;
    top: 50%;
    z-index: 99;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    // 竖屏
    &.vertical {
        width: 90vw;
        height: 60vh;
    }
    // 横屏
    &.horizontal {
        width: 70vw;
        height: 90vh;
    }
}
</style>
